import customEmojiConfig from '@/components/emoji/customEmojiConfig.json'
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
export async function asyncProcessArray(arr) {
  return new Promise((resolve) => {
    // 辅助函数：将时间戳转换为日期对象
    function timestampToDate(timestamp) {
      return new Date(timestamp);
    }

    function formatDate(date) {
      const now = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      const oneDay = 24 * 60 * 60 * 1000;
      const oneWeek = 7 * oneDay;

      if (now - date < oneDay && now.getDate() === date.getDate()) {
        return `${hours}:${minutes}`;
      } else if (now - date < oneDay * 2 && now.getDate() !== date.getDate()) {
        return `昨天 ${hours}:${minutes}`;
      } else if (now - date < oneWeek) {
        const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        return `${weekDays[date.getDay()]} ${hours}:${minutes}`;
      } else {
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }
    }

    const twentyTime = 20 * 60 * 1000;
    let previousTime = 0;

    arr.forEach((obj) => {
      const date = timestampToDate(obj.createTime);
      const dateString = formatDate(date);

      if (previousTime === 0 || obj.createTime - previousTime >= twentyTime) {
        obj.newtime = dateString;
        previousTime = obj.createTime;
      }
    });

    resolve(arr);
  });
}
export function toScroll() {
  setTimeout(() => {
    var div = document.getElementById("box-bd")
    if (div) {
      div.scrollTop = div.scrollHeight
    }
  }, 20);
}
//类型 10:文本消息,11:提示信息,13:用户进入聊天,14:转人工客服,15:菜单信息,20:图片消息，30：语音消息，40：订单消息，50：商品消息  17关键词拦截
export const sendType = {
  TEXT: 10,
  TOAST: 11,
  ENTER: 13,
  TRANSFER: 14,
  MENU: 15,
  WAYLAY: 17,
  IMG: 20,
  AUDIO: 30,
  ORDER: 40,
  PRODUCT: 50
}

export function filterMess(val, type) {
  const typeName = {
    11:val,
    10: val,
    20: '媒体信息',
    30: '语音信息',
    40: '订单信息',
    50: '商品信息'
  }
  return typeName[type]
}
export const processedContent = (val,size=16) => {
  if (val) {
    const isPlainText = !/<\/?[a-z][\s\S]*?>/i.test(String(val))

    let processed = String(val).replace(/&amp;/g, '&')

    // 纯文本：将完整链接转换为可点击的 a 标签，保留链接跳转能力
    // 已自带 HTML 的内容保持原样，避免重复处理或破坏原有 a 标签
    if (isPlainText) {
      processed = processed.replace(/(https?:\/\/[^\s<>"'，。；：！？、（）【】「」《》]+)/g, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="msg-link">${url}</a>`
      })
    }
    // 直接使用对象格式的配置
    const emojiMap = customEmojiConfig.customEmojis || {}

    // 构建正则表达式，匹配所有符号
    const symbols = Object.keys(emojiMap)
    if (symbols.length > 0) {
      // 按照符号长度从长到短排序，避免短符号优先匹配的问题
      const sortedSymbols = symbols.sort((a, b) => b.length - a.length)

      // 转义特殊字符用于正则表达式
      const escapedSymbols = sortedSymbols.map((symbol) => {
        // 对正则特殊字符进行转义
        const escaped = symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        return escaped
      })

      const symbolRegex = new RegExp(escapedSymbols.join('|'), 'g')

      // 将符号替换为对应的图片标签
      processed = processed.replace(symbolRegex, (match) => {
        console.log('匹配到的符号:', match)
        const filename = emojiMap[match]
        console.log('对应的文件名:', filename)

        if (filename) {
          const imageUrl = `https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/kf/${filename}`
          return `<img src="${imageUrl}" class="inline-emoji" alt="${match}" width='${size}' style="max-width: ${size}px;" />`
        }
        console.log('未找到对应的文件名，返回原符号')
        return match // 如果没有匹配到，返回原符号
      })
    } else {
      console.log('没有可用的表情符号配置')
    }
    // 换行统一转换为 <br>，不再受 isPlainText 限制
    // 已用 <br>/<div> 的 HTML 内容通常不含 \n，不会产生重复换行
    processed = processed.replace(/\r\n|\r|\n/g, '<br>')
    return processed
  } else {
    return ''
  }
}

export function useUniBridge() {
  const goToUniPage = (url, type = 'navigateTo') => {
    if (typeof uni !== 'undefined' && uni[type]) {
      uni[type]({ url })
    } else {
      console.error(`[Bridge Error] uni is not ready or ${type} is not a function.`)
    }
  }
  return { goToUniPage }
}